import { Component, AfterViewInit, ViewChild, NgZone, ElementRef } from '@angular/core';
//import { MdePopoverTrigger } from '@material-extended/mde';
import { ForTooltipComponent } from '../tooltip/for-tooltip.component';
import * as Highcharts from 'highcharts';
import { DataService } from '../../services/data.service';
import { AppService } from '../../services/app.service';
import { PaginatorService } from '../../services/paginator.service';
import { LoadingService } from '../../services/loading.service';
import { BehaviorSubject, } from 'rxjs';
import { Router } from '@angular/router';
import { EnumService } from '../../services/enum.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { DateTimeFormatService } from '../../services/datetime-format.service';


@Component({
  selector: 'app-xmlImportTestPublic',
  templateUrl: './xmlImportTestPublic.component.html',
})
export class XMLImportTestPublicComponent {

  @ViewChild('file', { static: true }) file: ElementRef;

  xmlValidationObject: any;
  showUploadButton = true;
  sendXMLValidationToEmail = false;
  sendXMLConfirmationToEmail = false;
  fileName = "";
  public form!: FormGroup;

  constructor(private router: Router, private dataService: DataService, public appService: AppService, public paginatorService: PaginatorService, private zone: NgZone
    , public enumService: EnumService, private fb: FormBuilder) {

  }

  resetXMLValidationObject() {
    this.xmlValidationObject = {
      ListOfInspectionDataPatient: [],
      ListOfInspectionDataRun: [],
      ListOfNotEligiblePatients: [],
      PatientRunErrors: [],
      XMLFormatErrorsList: [],
      XMLNotFormatedErrors: [],
      XMLRequiredFieldsAndWrongValuesErrorsList: [],
      ExistingPatients: [],
      PatientsToUpdateOrAdd: []
    }

    this.showUploadButton = true;
  }
  uploadFile() {
    //console.log(this.file.nativeElement.files);

    var twelveHourFormat = false;
    var dateFormatFromLocale = moment.localeData(window.navigator.language).longDateFormat('l');//.longDateFormat('L');
    var locale = '';
    if (this.form.controls['CultureOptionSelected'].value == 1) {//default culture 12h format
      locale = window.navigator.language;
      twelveHourFormat = true;
      dateFormatFromLocale = dateFormatFromLocale + ' hh:mm a';//+ ' hh:mm a';
    } else if (this.form.controls['CultureOptionSelected'].value == 2) {//default culture 24h format
      locale = window.navigator.language;
      twelveHourFormat = false;
      dateFormatFromLocale = dateFormatFromLocale + ' HH:mm';
    } else if (this.form.controls['CultureOptionSelected'].value == 3) {//en-US 12h format
      locale = 'en-US';
      twelveHourFormat = true;
      dateFormatFromLocale = 'M/D/YYYY hh:mm a';//dateFormatFromLocale = 'MMMM D YYYY hh:mm a';
    } else if (this.form.controls['CultureOptionSelected'].value == 4) {//en-US 24h format
      locale = 'en-US';
      twelveHourFormat = false;
      dateFormatFromLocale = 'M/D/YYYY HH:mm';//dateFormatFromLocale = 'MMMM D YYYY HH:mm';
    }
    var format = dateFormatFromLocale;
    this.form.controls['DatePickerType'].setValue(locale + '|' + format + '|' + twelveHourFormat);
    this.form.controls['DatePickerType'].updateValueAndValidity();
    if (this.file.nativeElement.files.length === 0) {
      return;
    }

    let fileToUpload = <File>this.file.nativeElement.files[0];
    const formData = new FormData();
    formData.append('uploadXMLFile', fileToUpload, fileToUpload.name);
    this.dataService.uploadXMLImportPublic('XMLImport/UploadXMLFileTest', formData, this.fileName, this.form.controls['SendXMLValidationToEmail'].value, this.form.controls['SendXMLConfirmationToEmail'].value
      , this.form.controls['UnitSystem'].value, this.form.controls['DatePickerType'].value, this.form.controls['CultureOptionSelected'].value, this.form.controls['UserEmail'].value).subscribe(
      (res: any) => {
        console.log('bingo');
       // this.resetXMLValidationObject();
        this.xmlValidationObject = res.data;
        console.log(this.xmlValidationObject);
      },
        err => {
          console.log('wwww');
        console.log(err);
      }
    )

    //reset input file value
    this.file.nativeElement.value = null;
  }

  updateAddPatientsAndRuns() {
    this.sendXMLValidationToEmail = null;
    this.sendXMLConfirmationToEmail = null;
    //Show message of import done, because we dont realy import data for XML import
    this.showUploadButton = false;
    this.fileName = "";
  }

  ngOnInit() {
    this.form = this.fb.group({
    });

    this.form = this.fb.group({
      UnitSystem: new FormControl(1, Validators.required),
      CultureOptionSelected: new FormControl(1, Validators.required),
      DatePickerType: new FormControl(1, Validators.required),
      SendXMLValidationToEmail: new FormControl(false),
      SendXMLConfirmationToEmail: new FormControl(false),
      UserEmail: new FormControl(null),
    });

    this.resetXMLValidationObject();
  }




}
